import { Component, OnInit, Input, ViewChild, ComponentFactoryResolver } from '@angular/core';

import { LayoutHostDirective } from '../layout-host.directive';

import { AbstractValidatorEditor } from '../../types/validator.types';
import { AbstractControl } from '../../types/control.types';
import { ControlValidatorSpecification } from '../../types/specification.types';
import { Subscription } from 'rxjs';
import { cloneDeep } from 'lodash';
import { ValidatorHandlerService } from '../../validator-handlers/validator-handler.service';

@Component({
  selector: 'df-validator-group',
  templateUrl: './validator-group.component.html',
  styleUrls: ['./validator-group.component.css']
})
export class ValidatorGroupComponent implements OnInit {
  @Input() groupName: string;

  @Input()
  get control(): AbstractControl<any> {
    return this._control;
  }
  set control(value: AbstractControl<any>) {
    this._control = value;
    this.loadComponents(this.validatorSpecifications);
  }

  @Input()
  get validatorSpecifications(): Array<ControlValidatorSpecification> {
    return this._validatorSpecifications;
  }
  set validatorSpecifications(value: Array<ControlValidatorSpecification>) {
    this._validatorSpecifications = value;
    this.loadComponents(value);
  }

  @ViewChild(LayoutHostDirective) layoutHost: LayoutHostDirective;

  private _control: AbstractControl<any>;
  private _validatorSpecifications: Array<ControlValidatorSpecification>;

  private _subscription: Array<Subscription>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private validatorHandlerService: ValidatorHandlerService
  ) {
    this._subscription = [];
  }

  ngOnInit() {}

  private loadComponents(specifications: Array<ControlValidatorSpecification>) {
    if (this.layoutHost) {
      this.layoutHost.viewContainerRef.clear();

      this._subscription.forEach((s) => {
        s.unsubscribe();
      });
      this._subscription = this._subscription.splice(0, this._subscription.length);
      if (!specifications || !this.control) {
        return;
      }
      for (const specification of specifications) {
        this.loadComponent(specification);
      }
    }
  }

  private loadComponent(specification: ControlValidatorSpecification) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(specification.component);
    const componentRef = this.layoutHost.viewContainerRef.createComponent(componentFactory);
    const instance = <AbstractValidatorEditor<any>>componentRef.instance;

    instance.control = this.control;
    instance.settings = specification.settings;
    instance.caption = specification.caption;
    instance.validatorName = specification.name;

    const model = this.control.model;
    if (!model.validators) {
      model.validators = {};
    }
    const value = model.validators[specification.name];
    instance.model = value;

    const subscription = instance.modelChange.subscribe((s: any) => {
      if (!instance.initComplete) {
        return;
      }
      const validatorName = specification.name;
      const handler = this.validatorHandlerService.getValidatorHandler(validatorName);
      if (handler) {
        handler.handleData(s, instance).subscribe(
          (i) => {
            this.control.model.validators[validatorName] = cloneDeep(i);
          },
          (error) => {
            instance.model = cloneDeep(this.control.model.validators[validatorName]);
          }
        );
      } else {
        this.control.model.validators[specification.name] = s;
      }
    });
    this._subscription.push(subscription);
  }
}
